/**
 * Модалка «лимит тарифа исчерпан»: открывается на любой ошибке
 * `LIMIT_REACHED_*` от API (`configureLimitHandler`) — экраны не обязаны
 * помнить о ней сами.
 */

import { create } from 'zustand';

import type { LimitReachedDetails } from '@aptile/shared';

import { configureLimitHandler } from '../api/client';

interface PaywallStore {
  readonly limit: LimitReachedDetails | null;
  /**
   * Сколько раз за сессию ученик получил +1 урок за рекламу: экран урока,
   * упёршийся в дневной лимит, следит за счётчиком и запрашивает урок снова.
   */
  readonly bonusGrants: number;
  open: (limit: LimitReachedDetails) => void;
  close: () => void;
  /** Бонусный урок начислен: модалка закрывается, экраны пробуют снова. */
  bonusGranted: () => void;
}

export const usePaywallStore = create<PaywallStore>()((set) => ({
  limit: null,
  bonusGrants: 0,
  open: (limit) => set({ limit }),
  close: () => set({ limit: null }),
  bonusGranted: () => set((state) => ({ limit: null, bonusGrants: state.bonusGrants + 1 })),
}));

// Любая ошибка лимита от API открывает модалку; экранам достаточно её не глушить.
configureLimitHandler((error) => {
  if (error.limit !== undefined) usePaywallStore.getState().open(error.limit);
});
